import { LocalPanelsProvider } from "providers";
import { IPanelsProvider } from "smarthub-common";
import {
  ISmartHubPanelProviderConfig,
  PanelsBaseProvider,
} from "smarthub-providers";
import { IProps } from "../props";

export const panels = (props: IProps): IPanelsProvider => {
  return new LocalPanelsProvider();

  const config: ISmartHubPanelProviderConfig = {
    auth: "login",
    uri: props.serviceUris.panel,
  };
  return new PanelsBaseProvider(config);
};
